var map = {
	"./cnn-money-x2.png": 2032,
	"./cnn-money.png": 2242,
	"./economist-x2.png": 2033,
	"./economist.png": 2243,
	"./mashable-x2.png": 2034,
	"./mashable.png": 2244,
	"./tech-crunch-x2.png": 2035,
	"./tech-crunch.png": 2245,
	"./thenewyorker-x2.png": 2036,
	"./thenewyorker.png": 2246,
	"./thrillist-x2.png": 2037,
	"./thrillist.png": 2247,
	"./time-x2.png": 2038,
	"./time.png": 2248,
	"./usa-today-x2.png": 2039,
	"./usa-today.png": 2249
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2241;